import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import style from './AtheleteDesc.scss';// to import local scss fle

class AtheleteDesc extends Component {
  static propTypes = {
    viewer: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  render() {
    const renderAthlete = renderIf(this.props.viewer === 'athlete');
    const renderParent = renderIf(this.props.viewer === 'parents');
    const renderCoach = renderIf(this.props.viewer === 'coach');
    return (
      <div className={cn('col s12', style.signinSection)}>
        <div className={cn('col s12', style.signinHeader)}>
          <div className={cn('col s12', style.joinUsButtonContainer)}>
            <span>
              <Link to="/">
                <button>HOME</button>
              </Link>
              <Link to="/about">
                <button>ABOUT</button>
              </Link>
              <Link to="/sports">
                <button>SPORTS</button>
              </Link>
              <Link to="/ourresults">
                <button>OUR RESULTS</button>
              </Link>
              <Link to="/contact">
                <button>CONTACT</button>
              </Link>
            </span>
          </div>
        </div>
        <div className={cn('col s12', style.signinBody)}>
          <span className={cn('col s12', style.signinBodyAlignCenter)}>
            {renderAthlete(
              <span>
                <h1>For Athletes</h1>
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span><br />
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span>
              </span>,
              )}
            {renderParent(
              <span>
                <h1>For Parents</h1>
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span><br />
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span>
              </span>,
              )}
            {renderCoach(
              <span>
                <h1>For Coach</h1>
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span><br />
                <span>Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry. Lorem Ipsum has been the
                        industrys standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                        It has survived not only five centuries, but also the
                        leap into electronic typesetting, remaining essentially
                        unchanged. It was popularised in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and more recently with desktop
                        publishing software like Aldus PageMaker including
                        versions of Lorem Ipsum.</span>
              </span>,
              )}
          </span>
        </div>
      </div>
    );
  }
}

export default AtheleteDesc;




// WEBPACK FOOTER //
// ./src/components/AtheleteDetails/AtheleteDesc.js